import { createContext } from 'react'

export const FileUploadContext = createContext({
  disabled: false,
  dropping: false,
  dropped: false,
})
